
interface CircuitBreakerState {
  failures: number;
  lastFailureTime: number;
  state: 'closed' | 'open' | 'half-open';
}

class CircuitBreaker {
  private state: CircuitBreakerState = {
    failures: 0,
    lastFailureTime: 0,
    state: 'closed'
  };
  
  private readonly maxFailures: number;
  private readonly resetTimeout: number;
  
  constructor(maxFailures = 5, resetTimeout = 30000) {
    this.maxFailures = maxFailures;
    this.resetTimeout = resetTimeout;
  }
  
  async execute<T>(operation: () => Promise<T>): Promise<T> {
    if (this.state.state === 'open') {
      if (Date.now() - this.state.lastFailureTime > this.resetTimeout) {
        this.state.state = 'half-open';
      } else {
        throw new Error('Circuit breaker is open');
      }
    }
    
    try {
      const result = await operation();
      this.onSuccess();
      return result;
    } catch (error) {
      this.onFailure();
      throw error;
    }
  }
  
  private onSuccess(): void {
    this.state.failures = 0;
    this.state.state = 'closed';
  }
  
  private onFailure(): void {
    this.state.failures++;
    this.state.lastFailureTime = Date.now();
    
    if (this.state.failures >= this.maxFailures) {
      this.state.state = 'open';
    }
  }
  
  isOpen(): boolean {
    return this.state.state === 'open';
  }
}

export const permissionsCircuitBreaker = new CircuitBreaker(3, 30000);
